$('.select-all').on('change', function() {
    var checked = this.checked;
    $(this).parents('li').first().find("input").each(function(){
        this.checked = checked;
    })
});

$('.get-all').on('click', function(){
    $(this).parents('.download-center').find('input[type=checkbox]').prop('checked', true);
});